import search from "../../assets/icons/search.svg";

type SearchProps = {
  searchInput: any;
  setSearchInput: any;
  placeholder: string;
  setSearch?: any;
};
const SearchComponent = ({
  searchInput,
  setSearchInput,
  placeholder,
  setSearch,
}: SearchProps) => {
  return (
    <div className="flex items-center w-full justify-center z-[2]">
      {" "}
      <div className=" flex justify-between border-trans21 border rounded-[10px] px-1 pl-5 py-1 text-black bg-white md:w-[50%]">
        <div className="flex items-center gap-5 w-full">
          <img src={search} alt="" className="w-4 h-4" />
          <input
            type="search"
            placeholder={placeholder}
            className="outline-none w-full text-xs"
            value={searchInput}
            onChange={setSearchInput}
          />
        </div>
        <button
          type="button"
          className="ml-6 rounded-[6px] border-0 bg-[#FA8151] font-semibold text-sm text-white h-10 px-8"
          onClick={setSearch}
        >
          Search
        </button>
      </div>
    </div>
  );
};

export default SearchComponent;
